<template>
    <div>
        <h4 class="title is-6">Teams</h4>

        <space-teams-form
            v-if="space_permission('SPACE_TEAM_CREATE', space)"
            :space_id="space.id"
            @created="load"/>

        <space-teams-list
            :space="space"
            :space_teams="list.data.results || []"
            :loading="list.loading"
            @removed="load"/>
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import SpaceTeamsForm from './SpaceTeamsForm.vue';
import SpaceTeamsList from './SpaceTeamsList.vue';

export default {
    components: { SpaceTeamsForm, SpaceTeamsList },
    props: { space: Object },
    computed: {
        ...mapState('space_teams', ['list']),
        ...mapGetters('space_teams', { init_value: 'as_teams' }),
    },
    created() {
        this.load();
    },
    methods: {
        load() {
            this.$store.dispatch('space_teams/list', { space_id: this.space.id });
        },
    },
};
</script>
